<template>
  <div>
    <div class="bg-white p-1 rounded shadow cursor-pointer d-flex justify-content-between align-items-center"
         :class="{'border' : selectedCustomFilter === status.key}"
         :style="{'border-color' : selectedCustomFilter === status.key ? status.color + '!important' : ''}"
         @click="doCustomFilter">
      <!-- doCustomFilter('statusId',status.key) -->
      <span class="text-capitalize">{{ status.value }} ({{ status.count }})</span>

      <!--<div class="p-2 rounded-circle position-lg-relative"
           :style="{'background-color' : status.color}">
                    <span v-show="selectedCustomFilter === status.key"
                          class="icon-check xy-align icon-xxs text-white"></span>
      </div>-->
    </div>
    <div class="border-bottom-3 mt-1" :style="{'color' : status.color }"></div>

  </div>
</template>

<script>
export default {
  name: "StatusFilter",
  props: {status: Object, isSelected: false},
  data() {
    return {
      selectedCustomFilter: null,

    }
  },
  methods: {
    doCustomFilter() {
      this.$emit("selected", this.status.key)
    }
  }
}
</script>

<style scoped>

</style>
